export const UserRepository = Symbol.for('UserRepository');
